var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.progress > 0)?_c('div',{staticClass:"fixprogress"},[_c('div',{staticClass:"progress"},[_c('span',{style:(`width: ${_vm.progress}%;`)},[_c('span',[_vm._v(_vm._s(_vm.progress)+"%")])])]),(_vm.showCancel)?_c('div',{staticClass:"cancel",on:{"click":_vm.cancel}},[_vm._v("cancel")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }